module.exports = __webpack_public_path__ + "06_long_gray.ecdeb0ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_long_gray.png
// module id = tU9O
// module chunks = 0